import { Component, Input, OnInit, ElementRef, Optional, OnDestroy } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import { IcosMenu } from './menu'
import { IcosSubmenu } from './submenu'
import { isParentTag, removeNgTag } from '../shared/utils'
import { Router } from '@angular/router'

@Component({
  selector: 'icos-menu-item',
  template: `
    <li
      class="icos-menu-item"
      (click)="clickHandle()"
      #list
      [ngStyle]="{
        paddingLeft: '20px',
        backgroundColor: rootMenu.backgroundColor || '',
        borderBottomColor: borderColor(),
        color: color()
      }"
      (mouseenter)="list.style.backgroundColor = rootMenu.hoverBackgroundColor()"
      (mouseleave)="list.style.backgroundColor = rootMenu.backgroundColor || ''"
      [class.is-active]="rootMenu.model === index"
      [class.is-disabled]="icosDisabled"
    >
      <ng-content></ng-content>
    </li>
  `
})
export class IcosMenuItem implements OnInit, OnDestroy {
  private buttonElement
  private parentElement

  @Input() set disabled(val: boolean) {
    // todo, is discarded.
    console.warn('icos Angular: (disabled) is discarded, use [icosDisabled] replace it.')
  }
  @Input() icosDisabled: boolean = false
  @Input() index: string
  @Input() title: string = ''
  @Input() to: string
  @Input() extras?: any = {}
  private inSubmenu: boolean = false

  constructor(
    @Optional() public rootMenu: IcosMenu,
    @Optional() private subMenu: IcosSubmenu,
    private sanitizer: DomSanitizer,
    private el: ElementRef,
    private router: Router
  ) {}

  clickHandle(): void {
    const comRef: any = this.subMenu || this.rootMenu
    comRef.selectHandle(this.index)
    const nextBorderIndex: string = this.inSubmenu && this.subMenu ? this.subMenu.index : this.index
    this.rootMenu.showBorderIndex = nextBorderIndex
    this.to && this.router.navigateByUrl(this.to, this.extras)
  }

  borderColor(): string {
    // not show border in group
    const dontShowBorder = this.inSubmenu && this.subMenu
    if (dontShowBorder) return 'transparent'
    return this.rootMenu.showBorderIndex === this.index
      ? this.rootMenu.activeTextColor
        ? this.rootMenu.activeTextColor
        : ''
      : 'transparent'
  }

  color(): string {
    return this.rootMenu.model === this.index
      ? this.rootMenu.activeTextColor && this.rootMenu.activeTextColor
      : this.rootMenu.textColor && this.rootMenu.textColor
  }

  ngOnInit(): void {
    this.rootMenu.showBorderIndex = this.rootMenu.model;
    this.buttonElement = this.el.nativeElement.firstChild
    this.parentElement = this.el.nativeElement.parentElement
    this.inSubmenu = isParentTag(this.el.nativeElement, 'icos-submenu')
    removeNgTag(this.el.nativeElement)
  }

  ngOnDestroy() {
    if (this.buttonElement && this.parentElement) {
      this.parentElement.removeChild(this.buttonElement)
    }
  }
}
